// extracted by mini-css-extract-plugin
module.exports = {"formError":"FormError_formError__yytwO","icon":"FormError_icon__xaEjj","label":"FormError_label__feaMf"};